import { getRandomImage, getStorageImage } from "helpers";

const isDev = process.env.REACT_APP_ENV === "dev";

const getDoctorImage = (id: string, path: string): string => {
  return isDev
    ? getRandomImage(id)
    : getStorageImage(path, "doctors-onboarding");
};

export { getDoctorImage };
